const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device
}
export default getters
